import { ReactComponent as LoaderIcon } from 'assets/images/loader.svg';
import axios from 'axios';
import request from 'lib/request';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import './CsvImport.scss';
import StatusProgressPanel from './StatusProgressPanel';


function StateAnalyzing({ type, onFinished }) {
  const [importProgressData, setImportProgressData] = useState(null);

  useEffect(() => {
    let ticker;
    let errorsCount = 0;
    // true if component is unmounted and ignore request responses
    let unmounted = false;
    const cancelRequest = axios.CancelToken.source();
    let isFinished = false;

    function checkUploadStatus() {
      request
        .get(`/imports/job-status?jobType=${type}${isFinished ? '' : '&isSummary=true'}`, {
          cancelToken: cancelRequest.token,
        })
        .then((data) => {
          if (unmounted) {
            return;
          }
          if (data?.status === 'finished') {
            if (!isFinished) {
              isFinished = true;
              ticker = setTimeout(checkUploadStatus, 2000);
            } else {
              onFinished(data);
            }
          } else if (data?.status === 'active') {

            setImportProgressData(data);

            // check for status changes in 2 seconds
            ticker = setTimeout(checkUploadStatus, 2000);
          } else {
            onFinished();
          }
        })
        .catch(() => {
          if (unmounted) {
            return;
          }
          ++errorsCount;
          // try 2 times to get data
          if (errorsCount < 2) {
            ticker = setTimeout(checkUploadStatus, 3000);
          } else {
            onFinished();
          }
        });
    }

    checkUploadStatus();
    return () => {
      unmounted = true;
      cancelRequest.cancel();
      if (ticker) {
        clearTimeout(ticker);
      }
    };
  }, [onFinished, type]);

  const isImporting = useMemo(() => {
    let output = false;

    if (importProgressData) {
      const { totalCount, successCount, warningCount, failedCount } = importProgressData;
      if (totalCount > 0 && (successCount > 0 || warningCount > 0 || failedCount > 0)) {
        output = true;
      }
    }

    return output;

  }, [JSON.stringify(importProgressData)]);

  const isAnalyzing = !isImporting && importProgressData?.status === 'active';

  return (
    <div className='stateAnalyzing'>
      {(isAnalyzing) && (
        <>
          <div className='loader'>
            <LoaderIcon />
          </div>
          <div>Analyzing file...</div>
        </>
      )}
      {(isImporting) && (
        <StatusProgressPanel statusData={importProgressData} />
      )}
    </div>
  );
}

StateAnalyzing.propTypes = {
  type: PropTypes.string.isRequired,
  onFinished: PropTypes.func.isRequired,
};

export default StateAnalyzing;
